import { Box, useTheme, Typography } from '@mui/material';

export function PagePanel({ children, ...other}) {
    const theme = useTheme();
    return (
        <Box mb={6} p={2} borderColor={theme.palette.border.primary} {...other}>{children}</Box>
    )
}

export function BorderedPagePanel({ children, ...other }) {
    const theme = useTheme()
    return (
        <Box sx={{borderBottom: '1px solid'}} mb={6} p={2} borderColor={theme.palette.border.primary} {...other}>{children}</Box>
    )
}

export function PageHeading({ children, ...other }) {
    const theme = useTheme();
    return (
        <Box sx={{borderBottom: '1px solid'}} mb={6} p={2} borderColor={theme.palette.border.primary} >
        <Typography variant="h2" sx={{ py: 2, color: theme.palette.text.secondary }} {...other}>
            {children}
        </Typography>
        </Box>
    );
}


export function TabPanel(props) {
    const { children, value, index, id, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`${id}-tabpanel-${index}`}
            aria-labelledby={`tab-${id}-${index}`}
            style={{display : 'flex', flex :1, flexDirection: 'column', height:'100%'}}
            {...other}
        >
            {value === index && (
                <Box sx={{ pv: 3, display : 'flex', flex :1, flexDirection: 'column',height:'100%' }}>
                    {children}
                </Box>
            )}
        </div>
    );
}